import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'contact_number_type.home.title',
    defaultMessage: 'Home',
  },
  work: {
    id: 'contact_number_type.work.title',
    defaultMessage: 'Work',
  },
  fax: {
    id: 'contact_number_type.fax.title',
    defaultMessage: 'Fax',
  },
  mobile: {
    id: 'contact_number_type.mobile.title',
    defaultMessage: 'Mobile',
  },
  phone: {
    id: 'contact_number_type.phone.title',
    defaultMessage: 'Phone',
  },
  altphone: {
    id: 'contact_number_type.altphone.title',
    defaultMessage: 'Alternative phone',
  }
});
